import type { UndrawScene } from '@/lib/undraw-illustrations';
import { UndrawIllustration } from '@/components/common/UndrawIllustration';
import { cn } from '@/lib/utils';

type EmptyStatePanelProps = {
  message: string;
  scene?: UndrawScene;
  className?: string;
};

export function EmptyStatePanel({
  message,
  scene = 'void',
  className,
}: EmptyStatePanelProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 px-4 py-8 text-center',
        className,
      )}
    >
      <UndrawIllustration
        scene={scene}
        title={message}
        className="h-36 w-full max-w-[280px] shrink-0 opacity-95"
      />
      <p className="max-w-md text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
